import { MainHeader } from "../../common/components/MainHeader";
import { Grid, Segment } from "semantic-ui-react";
import React from "react";
import { HeaderItem } from "../../common/components/HeaderItem";
import { EmployeePositionChangeModal } from "./EmployeePositionChangeModal";
import { EmployeeManagerChangeModal } from "./EmployeeManagerChangeModal";
import { EmployeeAreaChangeModal } from "./EmployeeAreaChangeModal";
import { Icons } from "../../common/Icons";
import { LinkEmployee } from "../Routes";
import { LinkArea } from "../../areas/Routes";
import { LinkPosition } from "../../positions/Routes";
import { useAsync } from "react-async";
import { AxiosEmployeeAPI } from "../Api";
import { PlaceholderHeader } from "../../common/components/PlaceholderHeader";
import { startDateInfo } from "../../utils/date";

const EmployeeDetailCurrentManager = ({ manager }) => {
  const value = manager && <LinkEmployee employee={manager} />;

  return <HeaderItem label="Gestor" icon={Icons.MANAGER} value={value} />;
};

const EmployeeDetailCurrentPosition = ({ position }) => {
  const value = position && <LinkPosition position={position} />;

  return <HeaderItem label="Cargo" icon={Icons.POSITION} value={value} />;
};

const EmployeeDetailCurrentArea = ({ area }) => {
  const value = area && <LinkArea area={area} />;

  return <HeaderItem label="Área" icon={Icons.AREA} value={value} />;
};

const EmployeeGeneralInfo = ({ employee }) => {
  let startDate = employee.current_record?.timespan.lower;

  return (
    <Segment padded>
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <HeaderItem
              icon={Icons.EMAIL}
              label="E-mail"
              value={employee?.email || "-"}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <HeaderItem
              icon={Icons.CPF}
              label="Código do funcionário"
              value={employee.employee_code}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <HeaderItem
              icon={Icons.COMPANY}
              label={startDate ? `Ativo ${startDate.fromNow()}` : "-"}
              value={startDateInfo(startDate)}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

const EmployeeActionableInfo = ({
  employee,
  manager,
  position,
  area,
  reload,
}) => {
  return (
    <Segment padded>
      <Grid>
        <Grid.Row>
          <Grid.Column width={10}>
            <EmployeeDetailCurrentManager manager={manager} />
          </Grid.Column>
          <Grid.Column width={6} textAlign={"right"}>
            <EmployeeManagerChangeModal
              employee={employee}
              currentManager={manager}
              reload={reload}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={10}>
            <EmployeeDetailCurrentPosition position={position} />
          </Grid.Column>
          <Grid.Column width={6} textAlign={"right"}>
            <EmployeePositionChangeModal
              employee={employee}
              currentPosition={position}
              reload={reload}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={10}>
            <EmployeeDetailCurrentArea area={area} />
          </Grid.Column>
          <Grid.Column width={6} textAlign={"right"}>
            <EmployeeAreaChangeModal
              employee={employee}
              currentArea={area}
              reload={reload}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

const EmployeeHeader = ({ employee, reload }) => {
  let manager = employee.current_manager?.manager;
  let area = employee.current_area?.area;
  let position = employee.current_position?.position;

  return (
    <>
      <Grid stackable style={{ marginTop: "0", marginBottom: "0" }}>
        <Grid.Column width={8}>
          <EmployeeGeneralInfo employee={employee} />
        </Grid.Column>
        <Grid.Column width={8}>
          <EmployeeActionableInfo
            employee={employee}
            manager={manager}
            position={position}
            area={area}
            reload={reload}
          />
        </Grid.Column>
      </Grid>
    </>
  );
};

export const EmployeeDetailHeader = ({ employee_id }) => {
  const { data, isPending, error, reload } = useAsync({
    promiseFn: AxiosEmployeeAPI.getById,
    watch: employee_id,
    employee_id: employee_id,
    expand: "_extra",
  });

  if (isPending) return <PlaceholderHeader />;
  if (error) return <MainHeader title="(Funcionário desconhecido)" />;
  if (data) return <EmployeeHeader employee={data} reload={reload} />;
};
